import { React } from 'react'
import { Box, Typography, useMediaQuery, Card, Divider, Skeleton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ErrorIcon from '@mui/icons-material/Error'
import Tooltip from '@mui/material/Tooltip'

const ACExternalEvalDataTable = ({ staffData, externalLoading }) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          backgroundColor: 'white.main',
          width: '100%',
          maxHeight: '300px',
          overflow: 'auto',
        }}
      >
        {staffData &&
          staffData?.map((item, index) => (
            <>
              {externalLoading ? (
                matches ? (
                  <>
                    <Box key={index}>
                      <Box width={'100%'} display={'flex'}>
                        <Box p={2} width={1 / 3}>
                          <Skeleton height={30} width={'100%'} />
                        </Box>
                        <Box p={2} width={1 / 3}>
                          <Skeleton height={30} width={'100%'} />
                        </Box>
                        <Box p={2} width={1 / 3}>
                          <Skeleton height={30} width={'100%'} />
                        </Box>
                      </Box>
                      <Divider light />
                    </Box>
                  </>
                ) : (
                  <>
                    <Box key={index}>
                      <Box display={'flex'} flexDirection={'row'} width="100%">
                        <Box p={2} width={1 / 3}>
                          <Skeleton height={50} width={'100%'} />
                        </Box>
                        <Box p={2} width={1 / 3}>
                          <Skeleton height={50} width={'100%'} />
                        </Box>
                        <Box p={2} width={1 / 3}>
                          <Skeleton height={50} width={'100%'} />
                        </Box>
                      </Box>
                      <Divider light />
                    </Box>
                  </>
                )
              ) : (
                <>
                  <Box key={index}>
                    <Box py={2} px={3} display={'flex'} alignItems={'center'}>
                      <Box width={1 / 3} display={'flex'} justifyContent={'center'}>
                        {item.errors.length !== 0 && (
                          <Tooltip
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  whiteSpace: 'pre-wrap',
                                },
                              },
                            }}
                            title={
                              item.errors.length > 1
                                ? item.errors.map((layout, order) => {
                                    return order + 1 + ') ' + layout + '\n'
                                  })
                                : item.errors[0]
                            }
                            placement="bottom-start"
                          >
                            <ErrorIcon sx={{ color: 'error.main', mr: 1.25 }} />
                          </Tooltip>
                        )}
                        <Typography align="center" variant="subtitle1" color="dark-gray-text.main">
                          {item.name}
                        </Typography>
                      </Box>

                      <Box width={1 / 3}>
                        <Typography
                          align="center"
                          variant="subtitle1"
                          color={
                            item.errors !== 0
                              ? item.errors.find(
                                  (bool) => bool === 'A staff with this email already exists'
                                )
                                ? 'error.main'
                                : 'dark-gray-text.main'
                              : 'dark-gray-text.main'
                          }
                        >
                          {item.email}
                        </Typography>
                      </Box>

                      <Box width={1 / 3} pl={2}>
                        <Typography
                          align="center"
                          variant="subtitle1"
                          color={
                            item.errors !== 0
                              ? item.errors.find(
                                  (bool) => bool === 'This department does not exist'
                                )
                                ? 'error.main'
                                : 'dark-gray-text.main'
                              : 'dark-gray-text.main'
                          }
                        >
                          {item.score}
                        </Typography>
                      </Box>
                    </Box>
                    <Divider light />
                  </Box>
                </>
              )}
            </>
          ))}
      </Card>
    </>
  )
}

export default ACExternalEvalDataTable
